// Ajout d'une bannière pour service Merci Gustave
export default function (modeBann, bannTxt, hostReturned) {
	const bann = document.createElement('div');
	bann.id = "gustave-bann";

	if (hostReturned === "www.editionsmr.fr") {
			bann.innerHTML = '<p style="display:block;margin:0;padding:0 24px;box-sizing:border-box;color:white; line-height:14px; text-align:center;font-size:' + (window.innerWidth > 350? '13px':'11px') + '">' + bannTxt + '</span></p><span id="closeBtn" style="position:absolute;top:4px;right:0px;padding:2px 10px;display:block;cursor:pointer;">x</span>';

	} else if (hostReturned === "dianavaradi.com") {
			bann.innerHTML = '<p style="display:block;margin:0;padding:0;box-sizing:border-box;color:white; line-height: 11px; text-align: center">' + bannTxt + '</p><span id="closeBtn" style="position:absolute;top:0;right:0px;padding:2px 10px;display:block;cursor:pointer;">x</span>';

	} else {
			bann.innerHTML = '<p style="display:block;margin:0;padding:0;box-sizing:border-box;color:white; line-height: 11px; text-align: center">' + bannTxt + '</p><span id="closeBtn" style="position:absolute;top:0;right:0px;padding:2px 10px;display:block;cursor:pointer;">x</span>';
	}

	// styles
	bann.style.position = "fixed";
	bann.style.zIndex = "1000000";
	bann.style.top = "0";
	bann.style.left = "0";
	bann.style.width = "100%";
	bann.style.height = "32px";
	bann.style.display = "none";
	bann.style.justifyContent = "center";
	bann.style.alignItems = "center";
	bann.style.background = "black";
	bann.style.color = "white";
	document.body.appendChild(bann);
	document.querySelector("#gustave-bann #closeBtn").onclick = hideBann;
	if(modeBann === "show") showBann();
  else if(modeBann === "hide") hideBann(); 
  
  function showBann() {
    if (modeBann !== "show") modeBann = "show";
    window.addEventListener('resize', modifPageForBann);
    window.addEventListener('scroll', modifPageForBann);
    if (document.querySelector("#gustave-bann") && document.querySelector("#gustave-bann").style.display !== "flex") document.querySelector("#gustave-bann").style.display = "flex";
    if (document.querySelector("#gustave-bann")) modifPageForBann();
  }
  function hideBann() {
    if (modeBann !== "hide") modeBann = "hide";
    if (document.querySelector("#gustave-bann") && document.querySelector("#gustave-bann").style.display !== "none") document.querySelector("#gustave-bann").style.display = "none";
    if (document.querySelector("#gustave-bann")) modifPageForBann();
  }
  function modifPageForBann() {

    if (hostReturned === "17h10.com") {
        if (window.innerWidth > 560 && modeBann === "show") fontStyle("14px");
        else if (modeBann === "show") fontStyle("10px");

        if (modeBann === "show") {
            document.body.style.paddingTop = "28px";
            if (window.innerWidth < 798 && document.querySelector("#header")) document.querySelector("#header").style.top = "28px";
            else if (document.querySelector(".main_nav_wrapper.sticky_nav.sticky_nav--stick")) document.querySelector(".main_nav_wrapper.sticky_nav.sticky_nav--stick").style.paddingTop = "28px";
        } else {
            document.body.style.paddingTop = "0px";
            if (window.innerWidth < 798 && document.querySelector("#header")) document.querySelector("#header").style.top = "0px";
            else if (document.querySelector(".main_nav_wrapper.sticky_nav.sticky_nav--stick")) document.querySelector(".main_nav_wrapper.sticky_nav.sticky_nav--stick").style.paddingTop = "0px";
        }
    }
    if(hostReturned === "dianavaradi.com") {
        if (window.innerWidth > 560 && modeBann === "show") fontStyle("14px");
        else if (modeBann === "show") fontStyle("12px");

        if (modeBann === "show") {
            if (document.querySelector("#masthead.stuck.move_down")) {
                document.querySelector("#gustave-bann").style.display = "none";
                document.querySelector("body").style.paddingTop = "0px";
            } else {
                document.querySelector("body").style.paddingTop = "28px";
                document.querySelector("#gustave-bann").style.display = "flex";
                if (document.URL !== "https://dianavaradi.com/") {
                    document.querySelector("#gustave-bann > p").style.textDecoration = "underline";
                    document.querySelector("#gustave-bann > p > span").style.textDecoration = "underline";
                } else {
                    document.querySelector("#gustave-bann > p").style.textDecoration = "none";
                    document.querySelector("#gustave-bann > p > span").style.textDecoration = "none";
                }
                if (window.innerWidth >= 740) document.querySelector("#gustave-bann > p > span").style.display = "inline-block";
                else document.querySelector("#gustave-bann > p > span").style.display = "block";
            }
        } else {
            document.querySelector("#gustave-bann").style.display = "none";
            document.querySelector("body").style.paddingTop = "0px";
        }
    }
    if (hostReturned === "www.editionsmr.fr" && document.querySelector("#gustave-bann > p")) {
      if (modeBann === "show") {
        document.querySelector("#gustave-bann").style.background = "#7C98B0";
        document.querySelector("body").style.paddingTop = "32px";
        if (document.querySelector("header#header")) {
          document.querySelector("header#header").style.top = "32px";
        }
        if (window.innerWidth > 350) {
          document.querySelector("#gustave-bann > p").style.fontSize = "13px";
         }else {
           document.querySelector("#gustave-bann > p").style.fontSize = "11px";
         }

      } else if (modeBann === "hide") {
        document.querySelector("body").style.paddingTop = "0";
        if (document.querySelector("header#header")) {
          document.querySelector("header#header").style.top = "0";
        }
      }
    }
  }
  function fontStyle(taille) {
    if (document.querySelector("#gustave-bann p") && document.querySelector("#gustave-bann span")) {
        document.querySelector("#gustave-bann p").style.fontSize = taille;
        document.querySelector("#gustave-bann span").style.fontSize = taille;
    }
  }
}